const ErrorQueryNames = {
    ErrorTitle: 'error_title',
    ErrorDescription: 'error_description',
    ShowBackButton: 'show_back_button',
};

export default ErrorQueryNames;
